<template>
  <v-container fluid>

    <v-layout wrap>
      <v-flex v-for="(card, i) in projectSummaryCards" :key="i">
        <v-card class="pa-2 ma-1 text-xs-center">
          <v-progress-circular :size="70" :width="10" :rotate="360" :value="projectStates[i] / totalProjects * 100" :color="card.color">
            {{projectStates[i]}}
          </v-progress-circular>
          <div class="title">{{card.title}}</div>
        </v-card>
      </v-flex>
    </v-layout>

    <v-card class="mt-2 mb-3">
      <v-card-title>
        <!-- Project dialog -->
        <v-dialog v-model="projectDialog" max-width="90%">
          <v-card>
            <v-card-title class="mb-0 pb-0">
              <v-flex xs6>
                <span class="headline">{{ projectFormTitle }}</span>
              </v-flex>
            </v-card-title>
            <v-card-text>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs12 v-if="gettingNewProjectId" class="text-xs-center">
                    <v-progress-circular indeterminate color="primary" size="50"></v-progress-circular>
                  </v-flex>
                  <v-flex xs12 v-else>
                    <v-alert type="error" v-model="saveProjectFailed" dismissible>An error occured when trying to save the project. Please try again.</v-alert>
                    <v-form ref="newProjectForm" v-model="newProjectValid">
                      <v-subheader>General</v-subheader>
                      <v-layout wrap>
                        <v-flex xs12 sm6 md4>
                          <v-text-field box v-model="editedProject.projectId" readonly label="Project ID"></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm6 md4>
                          <!-- <v-menu ref="projectDateDialog" v-model="projectDateDialog" lazy transition="scale-transition" offset-y full-width :nudge-right="40"
                            min-width="290px" :return-value.sync="editedProject.Date" :close-on-content-click="false"> -->
                            <v-text-field box label="Created Date" :value="editedProject.CreatedDate | formatDate" readonly></v-text-field>
                            <!-- <v-date-picker v-model="editedProject.CreatedDate" scrollable @input="$refs.projectDateDialog.save(editedProject.Date)"> -->
                            <!-- </v-date-picker> -->
                          <!-- </v-menu> -->
                        </v-flex>
                        <v-flex xs12 sm6 md4>
                          <v-select box v-model="editedProject.priority" label="Priority" item-text="text" item-value="value" :items="[{text:'High', value: 1},{text:'Medium', value: 2},{text:'Low', value: 3}]"></v-select>
                        </v-flex>
                        <v-flex xs12 sm6 md4>
                          <v-autocomplete box v-model="editedProject.jobType" label="Job Type" :items="['Order', 'Service Call']"></v-autocomplete>
                        </v-flex>
                        <v-flex xs12 sm6 md4>
                          <v-autocomplete box v-model="editedProject.Status" label="Project Status" :items="['CTN Sheet Approved', 'In Progress', 'Complete', 'Cancelled', 'In Query']" clearable></v-autocomplete>
                        </v-flex>
                        <v-flex xs12 sm6 md4>
                          <v-text-field box v-model="editedProject.manager" label="Project Manager(s)" readonly></v-text-field>
                        </v-flex>
                      </v-layout>
                      <v-subheader>Supplier</v-subheader>
                      <v-layout wrap>
                        <v-flex xs12 sm6 md4>
                          <v-autocomplete box v-model="editedProject.Supplier" label="Assign to Supplier" :items="suppliers" item-text="name" item-value="key" clearable></v-autocomplete>
                        </v-flex>
                        <v-flex xs12 sm6 md4>
                          <v-text-field box v-model="editedProject.supplierCost" type="number" label="Supplier Cost" prefix="£"></v-text-field>
                        </v-flex>
                      </v-layout>
                      <v-subheader>Zendesk</v-subheader>
                      <v-layout wrap>
                        <v-flex xs12 sm6 md4>
                          <v-text-field box v-model="editedProject.customerTicket" label="Zendesk - Customer Ticket"></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm6 md4>
                          <v-text-field box v-model="editedProject.BDMTicket" label="Zendesk - BDM Order Ticket"></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm6 md4>
                          <v-text-field box v-model="editedProject.engineerTicket" label="Zendesk - Engineer Ticket"></v-text-field>
                        </v-flex>
                      </v-layout>
                      <v-subheader>Finance - Customer</v-subheader>
                      <v-layout wrap>
                        <v-flex xs12 sm6 md4>
                          <v-autocomplete box v-model="editedProject.financeCustomer" label="Finance Status - Customer" :items="['Not Started', 'Invoiced', 'No Costs to Invoice', 'Query']" clearable></v-autocomplete>
                        </v-flex>
                        <v-flex xs12 sm6 md4>
                          <v-text-field box v-model="editedProject.financeInvoiced" label="Finance - Customer Invoiced" type="number" step="0.01" prefix="£"></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm6 md4>
                          <v-text-field box v-if="editedProject.jobType === 'Service Call'" v-model="editedProject.customerPO" label="Customer PO Number"></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm6 md4>
                          <v-text-field box v-if="editedProject.jobType === 'Service Call'" v-model="editedProject.customerCost" label="Customer Cost" type="number" step="0.01" prefix="£"></v-text-field>
                        </v-flex>
                      </v-layout>
                      <v-subheader>Finance - Supplier</v-subheader>
                      <v-layout wrap>
                        <v-flex xs12 sm6 md4>
                          <v-autocomplete box v-model="editedProject.financeSupplier" label="Finance Status - Supplier" :items="['Not Started', 'In Query', 'Supplier part Paid', 'Complete - Supplier Paid', 'Complete - No Cost']" clearable></v-autocomplete>
                        </v-flex>
                        <v-flex xs12 sm6 md4>
                          <v-text-field box v-model="editedProject.supplierPaid" label="Supplier Amount Paid" type="number" step="0.01" prefix="£"></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm6 md4>
                          <v-text-field box v-model="editedProject.supplierInvoiceNumbers" label="Supplier Invoice Numbers"></v-text-field>
                        </v-flex>
                        <v-flex xs12>
                          <v-textarea outline label="Notes" v-model="editedProject.notes"></v-textarea>
                        </v-flex>
                      </v-layout>
                     <v-list class="mt-3" avatar>
                        <v-list-tile v-for="doc in editedProject.attachedDocs" :key="doc.name">
                          <v-list-tile-avatar><v-icon>mdi-file-document-outline</v-icon></v-list-tile-avatar>
                          <v-list-tile-content>
                            <v-list-tile-title>
                              <a :href="doc.downloadUrl" target="_BLANK">{{doc.name}}</a>
                            </v-list-tile-title>
                          </v-list-tile-content>
                        </v-list-tile>
                      </v-list>
                    </v-form>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-btn color="red darken-1" flat @click.native="deleteProjectModal(editedProject)">Delete Project</v-btn>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" flat @click.native="closeProject">Close</v-btn>
              <v-btn color="green darken-1" flat @click.native="saveProject(true)" :disabled="!newProjectValid" :loading="savingSaveProject">Save</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-layout row wrap>
          <v-flex xs12 sm3 class="px-2">
            <v-select label="Filter by Project Status" :items="projectSummaryCards" item-value="title" item-text="title" v-model="projectStatusFilter" clearable single-line hide-details></v-select>
          </v-flex>
          <v-flex xs12 sm3 class="px-2">
            <v-select label="Filter by Finance Customer Status" :items="financeCustomerStatuses" v-model="financeCustomerStatusFilter" clearable single-line hide-details></v-select>
          </v-flex>
          <v-flex xs12 sm3 class="px-2">
            <v-select label="Filter by Finance Supplier Status" :items="financeSupplierStatuses" v-model="financeSupplierStatusFilter" clearable single-line hide-details></v-select>
          </v-flex>
          <v-flex xs12 sm3 class="px-2">
            <v-text-field append-icon="search" label="Search" single-line hide-details v-model="searchProject"></v-text-field>
          </v-flex>
        </v-layout>
      </v-card-title>
      <v-data-table :headers="projectHeaders" :items="filteredProjects" :search="searchProject" v-model="selectedProject" item-key="id" :loading="projectTableLoading" :pagination.sync="projectsPagination">
        <template slot="items" slot-scope="props">
          <tr @click.stop="props.expanded = !props.expanded; activeProject = props.item.projectId;">
            <td>{{ props.item.projectId }}</td>
            <td>{{ customerNameFromID(props.item.Customer) }}</td>
            <td>{{ props.item.CreatedDate | formatDate }}<v-chip v-if="props.item.CreatedDate == today" color="green" text-color="white" small>New</v-chip></td>
            <td>{{ supplierNameFromID(props.item.Supplier) }}</td>
            <td>{{ props.item.Status ? props.item.Status : 'Awaiting Approval' }}</td>
            <td>{{ props.item.financeCustomer ? props.item.financeCustomer : '' }}</td>
            <td>{{ props.item.financeSupplier ? props.item.financeSupplier : '' }}</td>
            <td>{{ props.item.supplierCost ? '£' + props.item.supplierCost : '' }}</td>
            <td>{{ props.item.supplierPaid ? '£' + props.item.supplierPaid : '' }}</td>
            <td>{{ props.item.financeInvoiced ? '£' + props.item.financeInvoiced : '' }}</td>
            <td class="text-xs-right">
              <v-btn icon class="mx-0" @click.stop="editProject(props.item)">
                <v-icon color="teal">edit</v-icon>
              </v-btn>
              <v-btn icon class="mx-0" @click.stop="deleteProjectModal(props.item)">
                <v-icon color="pink">delete</v-icon>
              </v-btn>
            </td>
          </tr>
        </template>
        <template slot="expand" slot-scope="props">
          <v-layout justify-center>
            <v-flex xs12>
              <v-card class="ma-2 elevation-0" width="100%">
                <v-flex xs8>
                  <v-list dark dense>
                    <v-list-tile>
                      <v-layout>
                        <v-flex xs3>
                          <v-list-tile-content>
                            Status
                          </v-list-tile-content>
                        </v-flex>
                        <v-flex xs3>
                          <v-list-tile-content>
                            Vehicle
                          </v-list-tile-content>
                        </v-flex>
                        <v-flex xs3>
                          <v-list-tile-content>
                            Date
                          </v-list-tile-content>
                        </v-flex>
                        <v-flex xs3>
                          <v-list-tile-content>
                            Job Number
                          </v-list-tile-content>
                        </v-flex>
                      </v-layout>
                    </v-list-tile>
                    <hr>
                    <v-list-tile v-for="(job, i) in expandedJobs(props.item.projectId)" v-bind:key="i">
                      <v-layout>
                        <v-flex xs3>
                          <v-list-tile-avatar>
                            <v-icon :color="job.Status >= 2 ? 'green' : job.Status === 1 ? 'red' : (job.Supplier === '' || job.Supplier === null) ? 'grey' : (job.Allocated === '' || job.Allocated === null) ? 'cyan' : 'orange'">assignment</v-icon>
                          </v-list-tile-avatar>
                        </v-flex>
                        <v-flex xs3>
                          <v-list-tile-content>
                            {{ job.Vehicle ? vehicleRegFromID(job.Vehicle) : job.vehReg }}
                          </v-list-tile-content>
                        </v-flex>
                        <v-flex xs3>
                          <v-list-tile-content>
                            {{job.Date | formatDate}}
                          </v-list-tile-content>
                        </v-flex>
                        <v-flex xs3>
                          <v-list-tile-content>
                            {{job.JobNo}}
                          </v-list-tile-content>
                        </v-flex>
                      </v-layout>
                    </v-list-tile>
                  </v-list>
                </v-flex>
                <v-flex xs12 class="mt-3">
                  <v-btn depressed class="primary" @click="exportFinance(props.item.projectId)"><v-icon left>mdi-content-copy</v-icon>Copy Table</v-btn>
                </v-flex>
                <v-flex xs12>
                  
                  <v-data-table select-all v-model="selectedJobs" dark :headers="financeHeaders" :items="financeItems" :search="searchFinance" :loading="financeTableLoading" :pagination.sync="financePagination">
                    <template slot="items" slot-scope="props">
                      <tr>
                        <td>
                          <v-checkbox
                            v-model="props.selected" primary
                            hide-details
                          ></v-checkbox>
                        </td>
                        <td>{{props.item.JobNo}}</td>
                        <td>{{props.item.VehicleReg}}</td>
                        <td>{{templateNameFromId(props.item.template)}}</td>
                        <td>{{props.item.paymentMethodsString}}</td>
                        <td>{{props.item.contractTermText}}</td>
                        <td>{{props.item.currencyText}}</td>
                        <td>{{props.item.upfrontPayment ? props.item.currencyText + props.item.upfrontPayment : ''}}</td>
                        <td>{{props.item.installationPayment ? props.item.currencyText + props.item.installationPayment : ''}}</td>
                        <td>{{props.item.rentalPayment ? props.item.currencyText + props.item.rentalPayment : ''}}</td>
                        <td>{{props.item.rentalFrequencyText}}</td>
                        <td>{{props.item.lessorText}}</td>
                        <td>{{props.item.leasePayment ? props.item.currencyText + props.item.leasePayment : ''}}</td>
                        <td>{{props.item.leaseFrequencyText}}</td>
                        <td>{{props.item.warrantyText}}</td>
                      </tr>
                    </template>
                    <template slot="footer">
                      <td></td>
                      <td><strong>TOTAL</strong></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td><strong>{{financeItemTotals(props.item.projectId).upfrontPaymentTotal > -1 ? financeItemTotals(props.item.projectId).upfrontPaymentTotal + 1 : ''}}</strong></td>
                      <td><strong>{{financeItemTotals(props.item.projectId).installationPaymentTotal > -1 ? financeItemTotals(props.item.projectId).installationPaymentTotal + 1 : ''}}</strong></td>
                      <td><strong>{{financeItemTotals(props.item.projectId).rentalPaymentTotal > -1 ? financeItemTotals(props.item.projectId).rentalPaymentTotal + 1 : ''}}</strong></td>
                      <td></td>
                      <td></td>
                      <td><strong>{{financeItemTotals(props.item.projectId).leasePaymentTotal > -1 ? financeItemTotals(props.item.projectId).leasePaymentTotal + 1 : ''}}</strong></td>
                      <td></td>
                      <td></td>
                    </template>
                  </v-data-table>
                </v-flex>
              </v-card>
            </v-flex>
          </v-layout>
          <v-layout row wrap v-if="props.item.attachedDocs">
            <v-flex xs12>
              <v-card class="my-2 pa-2 elevation-0" width="100%">
                <v-list class="mt-3" avatar>
                  <h5 class="title">Attached Documents</h5>
                  <v-list-tile v-for="doc in props.item.attachedDocs" :key="doc.name">
                    <v-list-tile-avatar><v-icon>mdi-file-document-outline</v-icon></v-list-tile-avatar>
                    <v-list-tile-content>
                      <v-list-tile-title>
                        <a :href="doc.downloadUrl" target="_BLANK">{{doc.name}}</a>
                      </v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </v-list>
              </v-card>
            </v-flex>
          </v-layout>
        </template>
      </v-data-table>
    </v-card>

    <!-- Delete project dialog -->
    <v-dialog v-model="deleteProjectDialog" max-width="750px" scrollable>
      <v-card>
        <v-card-title>
          <span class="headline">Delete Project</span>
        </v-card-title>
        <v-card-text>Please confirm whether you would also like to delete the related jobs with the project. Alternatively, you may want
          to cancel the project instead of deleting it.</v-card-text>
        <v-card-actions>
          <v-btn color="red darken-1" flat @click.native="deleteProject(false)" :loading="deletingProjectOnly" :disabled="deletingProjectAll || cancelProject">Delete project only</v-btn>
          <v-btn color="red darken-1" flat @click.native="deleteProject(true)" :loading="deletingProjectAll" :disabled="deletingProjectOnly || cancelProject">Delete project and jobs</v-btn>
          <v-btn color="orange darken-1" flat @click.native="cancelProject" :loading="cancelProject" :disabled="deletingProjectAll || deletingProjectOnly">Cancel Project</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" right flat @click.native="deleteProjectDialog = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    
    <!-- edit finance dialog -->
    <v-dialog v-model="editFinanceDialog" max-width="750px" scrollable>
      <v-card>
        <v-card-title>
          <span class="headline">Edit Finance Options</span>
        </v-card-title>
        <v-card-text>
          <v-select multiple :items="paymentMethods" chips label="Payment Method(s)" v-model="editFinance['paymentMethods']"></v-select>
          <v-select label="Contact Term" :items="contractTerms" v-model="editFinance['contractTerm']"></v-select>
          <v-select label="Currency" :items="currencies" v-model="editFinance['currency']"></v-select>
          <v-text-field label="Upfront Payment Per Unit" type="number" step="0.01" v-model="editFinance['upfrontPayment']" v-if="editFinance['paymentMethods'].includes('upfront-payment')"></v-text-field>
          <v-text-field label="Installation Payment Per Unit" type="number" step="0.01" v-model="editFinance['installationPayment']" v-if="editFinance['paymentMethods'].includes('upfront-installation')"></v-text-field>
          <v-text-field label="Rental Payment Per Unit" type="number" step="0.01" v-model="editFinance['rentalPayment']" v-if="editFinance['paymentMethods'].includes('rental')"></v-text-field>
          <v-select label="Rental Frequency" :items="rentalFrequencies" v-if="editFinance['paymentMethods'].includes('rental')" v-model="editFinance['rentalFrequency']"></v-select>
          <v-select label="Lessor" :items="lessors" v-if="editFinance['paymentMethods'].includes('lease')" v-model="editFinance['lessor']"></v-select>
          <v-text-field label="Lease Payment Per Unit" type="number" step="0.01" v-model="editFinance['leasePayment']" v-if="editFinance['paymentMethods'].includes('lease')"></v-text-field>
          <v-select label="Lease Frequency" :items="leaseFrequencies" v-if="editFinance['paymentMethods'].includes('lease')" v-model="editFinance['leaseFrequency']"></v-select>
          <v-select label="Warranty" :items="warranties" v-model="editFinance['warranty']"></v-select>
        </v-card-text>
        <v-card-actions>
          <v-btn color="blue darken-1" flat @click.native="selectedJobs = []; editFinanceDialog = false">Cancel</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" flat @click.native="saveEditedFinance" :loading="savingEditedFinance">Save Changes</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar
      v-model="copied"
      :timeout="5000"
      color="info"
      top>
      Table copied to clipboard
      <v-btn
        flat
        @click="copied = false"
      ><v-icon>mdi-close</v-icon></v-btn>
    </v-snackbar>

    <v-fab-transition>
      <v-btn
        v-show="selectedJobs.length > 0"
        color="primary"
        dark
        fab
        fixed
        bottom
        right
        @click="openEditFinanceDialog"
      >
        <v-icon>edit</v-icon>
      </v-btn>
    </v-fab-transition>
  </v-container>
</template>


<script>
import { fireStore } from '../firebase'
import moment from 'moment'
export default {
  props: ['customer', 'job'],
  data () {
    return {
      today: moment().format('YYYY-MM-DD'),
      selectedProject: [],
      selectedJobs: [],
      activeProject: '',
      saveProjectFailed: false,
      fab: false,
      projectSummaryCards: [
        {title: 'Awaiting Approval', color: 'grey'},
        {title: 'CTN Sheet Approved', color: 'cyan'},
        {title: 'Cancelled', color: 'red'},
        {title: 'In Progress', color: 'orange'},
        {title: 'Complete', color: 'green'}
      ],
      openProjectStatuses: ['Awaiting Approval', 'CTN Sheet Approved', 'In Progress'],
      addToProjectDialog: false,
      expanded: false,
      managerList: [],
      savingEditedFinance: false,
      gettingEngineers: false,
      gettingVehicles: false,
      projectDateDialog: false,
      editFinanceDialog: false,
      editFinance: {
        paymentMethods: []
      },
      sites: [],
      jobs: [],
      projectsPagination: {
        sortBy: 'CreatedDate',
        rowsPerPage: 25,
        page: 1,
        descending: true
      },
      projectHeaders: [
        {
          text: 'Project ID',
          value: 'projectId',
          align: 'left'
        },
        {
          text: 'Customer',
          value: 'Customer',
          align: 'left'
        },
        {
          text: 'Created Date',
          value: 'CreatedDate',
          align: 'left'
        },
        {
          text: 'Supplier',
          value: 'Supplier',
          align: 'left'
        },
        {
          text: 'Project Status',
          value: 'Status',
          align: 'left'
        },
        {
          text: 'Finance Status - Customer',
          value: 'financeCustomer',
          align: 'left'
        },
        {
          text: 'Finance Status - Supplier',
          value: 'financeSupplier',
          align: 'left'
        },
        {
          text: 'Supplier Cost',
          value: 'supplierCost',
          align: 'left'
        },
        {
          text: 'Supplier Paid',
          value: 'supplierPaid',
          align: 'left'
        },
        {
          text: 'Finance - Customer Invoiced',
          value: 'financeInvoiced',
          align: 'left'
        },
        {
          text: 'Actions',
          value: 'actions',
          align: 'right',
          sortable: false
        }
      ],
      searchProject: '',
      engineers: [],
      vehicles: [],
      supplierSelect: '',
      vehicleSelect: '',
      defaultItem: {
        Vehicle: null,
        vehReg: '',
        JobNo: null,
        templates: ['preCheck'],
        templateExtras: [],
        Supplier: '',
        Allocated: '',
        Date: null,
        Status: 0,
        additionalFields: [],
        extras: {},
        Project: null
      },
      tableLoading: false,
      projectTableLoading: false,
      openProjectTableLoading: false,
      states: [],
      projectStates: [],
      totalJobs: 0,
      totalProjects: 0,
      templateExtras: [],
      editedProjectIndex: -1,
      projectDialog: false,
      newProjectValid: false,
      editedProject: {
        id: '',
        totalJobs: 0,
        completedJobs: 0,
        Status: 0,
        manager: '',
        Date: null,
        BDM: '',
        customerTicket: '',
        engineerTicket: '',
        BDMTicket: '',
        financeCustomer: 0,
        financeInvoiced: null,
        financeSupplier: 0,
        supplierPaid: null,
        customerPO: null,
        customerCost: null,
        jobType: null
      },
      defaultProject: {
        id: '',
        totalJobs: 0,
        completedJobs: 0,
        Status: 0,
        manager: '',
        Date: null,
        BDM: '',
        customerTicket: '',
        engineerTicket: '',
        BDMTicket: '',
        financeCustomer: 0,
        financeInvoiced: null,
        financeSupplier: 0,
        supplierPaid: null,
        customerPO: null,
        customerCost: null,
        jobType: null
      },
      projects: [],
      gettingNewProjectId: false,
      newProject: false,
      deleteProjectDialog: false,
      deleteProjectData: {},
      assignToProject: null,
      assignToEngineerDialog: false,
      assignToEngineer: '',
      assignToSupplier: '',
      savingAddJobsToProject: false,
      savingAssignJobsToEngineer: false,
      savingSaveProject: false,
      savingSaveJob: false,
      cancelProject: false,
      deletingProjectAll: false,
      deletingProjectOnly: false,
      deleteJobsDialog: false,
      deletingJobs: false,
      approveJobsDialog: false,
      approvingJobs: false,
      approvingJob: false,
      approveDialog: false,
      statusFilter: null,
      projectStatusFilter: null,
      openProjectStatusFilter: null,
      Statuses: [
        {text: 'Not Started', value: 5},
        {text: 'Awaiting Install', value: 4},
        {text: 'Issue', value: 1},
        {text: 'Complete', value: 2},
        {text: 'Complete - NIBC Approved', value: 3}
      ],
      duplicateProjectSource: null,
      duplicateProjectSupplier: null,
      createNewProject: false,
      financeCustomerStatuses: ['Not Started', 'Invoiced', 'No Costs to Invoice', 'Query'],
      financeSupplierStatuses: ['Not Started', 'In Query', 'Supplier part Paid', 'Complete - Supplier Paid', 'Complete - No Cost'],
      financeSupplierStatusFilter: '',
      financeCustomerStatusFilter: '',
      financeHeaders: [
        {
          text: 'Job No.',
          value: 'JobNo',
          align: 'left'
        },
        {
          text: 'Vehicle Reg',
          value: 'Vehicle',
          align: 'left'
        },
        {
          text: 'Product',
          value: 'template',
          align: 'left'
        },
        {
          text: 'Payment Methods',
          value: 'paymentMethods',
          align: 'left'
        },
        {
          text: 'Contract Term',
          value: 'contractTermText',
          align: 'left'
        },
        {
          text: 'Currency',
          value: 'currencyText',
          align: 'left'
        },
        {
          text: 'Upfront Payment',
          value: 'upfrontPayment',
          align: 'left'
        },
        {
          text: 'Installation Payment',
          value: 'installationPayment',
          align: 'left'
        },
        {
          text: 'Rental Payment',
          value: 'rentalPayment',
          align: 'left'
        },
        {
          text: 'Rental Frequency',
          value: 'rentalFrequencyText',
          align: 'left'
        },
        {
          text: 'Lessor',
          value: 'lessorText',
          align: 'left'
        },
        {
          text: 'Lease Payment',
          value: 'leasePayment',
          align: 'left'
        },
        {
          text: 'Lease Frequency',
          value: 'leaseFrequencyText',
          align: 'left'
        },
        {
          text: 'Warranty',
          value: 'warrantyText',
          align: 'left'
        }
      ],
      searchFinance: null,
      financeTableLoading: false,
      financePagination: {
        sortBy: 'JobNo',
        rowsPerPage: -1,
        page: 1,
        descending: true
      },
      paymentMethods: [
        {text: 'Upfront Payment', value: 'upfront-payment'},
        {text: 'Upfront Installation', value: 'upfront-installation'},
        {text: 'Rental', value: 'rental'},
        {text: 'Lease', value: 'lease'}
      ],
      contractTerms: [
        {text: '30 Days', value: '30days'},
        {text: '60 Days', value: '60days'},
        {text: '90 Days', value: '90days'},
        {text: '6 Months', value: '6months'},
        {text: '9 Months', value: '9months'},
        {text: '12 Months', value: '12months'},
        {text: '18 Months', value: '18months'},
        {text: '24 Months', value: '24months'},
        {text: '36 Months', value: '36months'},
        {text: '48 Months', value: '48months'},
        {text: '60 Months', value: '60months'},
        {text: 'N/A', value: 'n/a'},
        {text: 'Demo', value: 'demo'}
      ],
      warranties: [
        {text: '30 Days', value: '30days'},
        {text: '60 Days', value: '60days'},
        {text: '90 Days', value: '90days'},
        {text: '6 Months', value: '6months'},
        {text: '9 Months', value: '9months'},
        {text: '12 Months', value: '12months'},
        {text: '18 Months', value: '18months'},
        {text: '24 Months', value: '24months'},
        {text: '36 Months', value: '36months'},
        {text: '48 Months', value: '48months'},
        {text: '60 Months', value: '60months'},
        {text: 'N/A', value: 'n/a'},
        {text: 'Demo', value: 'demo'}
      ],
      currencies: [
        {text: '£', value: 'gbp'},
        {text: '€', value: 'euro'}
      ],
      rentalFrequencies: [
        {text: 'Monthly', value: 'monthly'},
        {text: 'Quarterly', value: 'quarterly'},
        {text: 'Annual', value: 'annual'}
      ],
      lessors: [
        {text: 'LDF (White Oak)', value: 'ldf'},
        {text: 'Lease Telecom', value: 'lease-telecom'},
        {text: 'Grenke', value: 'grenke'}
      ],
      leaseFrequencies: [
        {text: 'Monthly', value: 'monthly'},
        {text: 'Quarterly', value: 'quarterly'}
      ],
      copied: false
    }
  },
  created () {
    this.getEngineers()
    // this.getJobs()
    this.getProjects()
    this.getVehicles()
    this.$store.dispatch('fetchCustomers')
    this.$store.dispatch('fetchProductTypes')
    this.$store.dispatch('fetchSuppliers')
  },
  mounted () {
    if (this.job !== undefined) {
      this.viewJob(this.job)
    }
    this.defaultProject.Date = moment().format('YYYY-MM-DD')
    this.editedProject.Date = moment().format('YYYY-MM-DD')
    // this.projectDateDialog = moment().format('YYYY-MM-DD')
  },
  computed: {
    customerList () {
      return this.$store.getters.customers
    },
    templates () {
      return this.$store.getters.productTypes
    },
    filteredJobs () {
      let jobs = this.jobs
      return jobs.filter((i) => {
        if (!this.statusFilter) {
          return true
        } else if (this.statusFilter === 3 && i.Status === 3) {
          return true
        } else if (this.statusFilter === 2 && i.Status === 2) {
          return true
        } else if (this.statusFilter === 1 && i.Status === 1) {
          return true
        } else if (this.statusFilter === 4 && i.Allocated && (!i.Status || i.Status < 1)) {
          return true
        } else if (this.statusFilter === 5 && !i.Allocated && (!i.Status || i.Status < 1)) {
          return true
        } else {
          return false
        }
      })
    },
    financeItems () {
      let jobs = this.expandedJobs(this.activeProject)
      console.log(jobs)
      let financeArr = []
      jobs.forEach(job => {
        if (job.finance && Object.keys(job.finance).length > 0) {
          for (const financeKey in job.finance) {
            let financeObj = job.finance[financeKey]
            financeObj['JobNo'] = job.JobNo
            financeObj['Vehicle'] = job.Vehicle
            financeObj['template'] = financeKey
            financeObj['VehicleReg'] = job.Vehicle ? this.vehicleRegFromID(job.Vehicle) : job.vehReg
            financeObj['id'] = job.JobNo + financeKey
            let paymentMethodTexts = []
            if (financeObj.paymentMethods) {
              financeObj.paymentMethods.forEach(paymentMethod => {
                const paymentMethodIndex = this.paymentMethods.findIndex(obj => {
                  return obj.value === paymentMethod
                })
                paymentMethodTexts.push(this.paymentMethods[paymentMethodIndex].text)
              })
            } else {
              break
            }
            financeObj['paymentMethodsString'] = paymentMethodTexts ? paymentMethodTexts.join(', ') : ''
            if (financeObj.contractTerm) {
              const contractTermIndex = this.contractTerms.findIndex(object => {
                return object.value === financeObj.contractTerm
              })
              if (contractTermIndex > -1) {
                financeObj.contractTermText = this.contractTerms[contractTermIndex].text
              }
            }
            if (financeObj.currency) {
              const currencyIndex = this.currencies.findIndex(object => {
                return object.value === financeObj.currency
              })
              if (currencyIndex > -1) {
                financeObj.currencyText = this.currencies[currencyIndex].text
              }
            }
            if (financeObj.rentalFrequency) {
              const rentalFrequencyIndex = this.rentalFrequencies.findIndex(object => {
                return object.value === financeObj.rentalFrequency
              })
              if (rentalFrequencyIndex > -1) {
                financeObj.rentalFrequencyText = this.rentalFrequencies[rentalFrequencyIndex].text
              }
            }
            if (financeObj.lessor) {
              const lessorIndex = this.lessors.findIndex(object => {
                return object.value === financeObj.lessor
              })
              if (lessorIndex > -1) {
                financeObj.lessorText = this.lessors[lessorIndex].text
              }
            }
            if (financeObj.leaseFrequency) {
              const leaseFrequencyIndex = this.leaseFrequencies.findIndex(object => {
                return object.value === financeObj.leaseFrequency
              })
              if (leaseFrequencyIndex > -1) {
                financeObj.leaseFrequencyText = this.leaseFrequencies[leaseFrequencyIndex].text
              }
            }
            if (financeObj.warranty) {
              const warrantyIndex = this.warranties.findIndex(object => {
                return object.value === financeObj.warranty
              })
              if (warrantyIndex > -1) {
                financeObj.warrantyText = this.warranties[warrantyIndex].text
              }
            }
            financeArr.push(financeObj)
          }
        }
      })
      return financeArr
    },
    filteredProjects () {
      let projects = this.projects
      return projects.filter((i) => {
        if (
          (this.projectStatusFilter === 'In Progress' && i.Status !== 'In Progress') ||
          (this.projectStatusFilter === 'Complete' && i.Status !== 'Complete') ||
          (this.projectStatusFilter === 'Cancelled' && i.Status !== 'Cancelled') ||
          (this.projectStatusFilter === 'CTN Sheet Approved' && i.Status !== 'CTN Sheet Approved') ||
          (this.projectStatusFilter === 'Awaiting Approval' && i.Status !== 'Awaiting Approval')) {
          return false
        } else if (
          (this.financeCustomerStatusFilter === 'Not Started' && i.financeCustomer !== 'Not Started') ||
          (this.financeCustomerStatusFilter === 'Invoiced' && i.financeCustomer !== 'Invoiced') ||
          (this.financeCustomerStatusFilter === 'No Costs to Invoice' && i.financeCustomer !== 'No Costs to Invoice') ||
          (this.financeCustomerStatusFilter === 'Query' && i.financeCustomer !== 'Query')) {
          return false
        } else if (
          (this.financeSupplierStatusFilter === 'Not Started' && i.financeSupplier !== 'Not Started') ||
          (this.financeSupplierStatusFilter === 'In Query' && i.financeSupplier !== 'In Query') ||
          (this.financeSupplierStatusFilter === 'Supplier Part Paid' && i.financeSupplier !== 'Supplier Part Paid') ||
          (this.financeSupplierStatusFilter === 'Complete - Supplier Paid' && i.financeSupplier !== 'Complete - Supplier Paid') ||
          (this.financeSupplierStatusFilter === 'Complete - No Cost' && i.financeSupplier !== 'Complete - No Cost')) {
          return false
        } else {
          return true
        }
      })
    },
    filteredOpenProjects () {
      return this.projects.filter((i) => {
        if (!this.openProjectStatusFilter) {
          return true
        } else if (this.openProjectStatusFilter === 'In Progress' && i.Status === 'In Progress') {
          return true
        } else if (this.openProjectStatusFilter === 'Complete' && i.Status === 'Complete') {
          return true
        } else if (this.openProjectStatusFilter === 'Cancelled' && i.Status === 'Cancelled') {
          return true
        } else if (this.openProjectStatusFilter === 'CTN Sheet Approved' && i.Status === 'CTN Sheet Approved') {
          return true
        } else if (this.openProjectStatusFilter === 'Awaiting Approval' && (i.Status === undefined || i.Status === null)) {
          return true
        } else {
          return false
        }
      })
    },
    formTitle () {
      return this.editedIndex === -1 ? 'New Job' : 'Edit Job'
    },
    projectFormTitle () {
      return this.editedProjectIndex === -1 ? 'New Project' : 'Edit Project'
    },
    suppliers () {
      return this.$store.getters.suppliers
    },
    currentJobNo () {
      if (this.currentJob) {
        const index = this.jobs.findIndex(job => {
          return this.currentJob === job.id
        })
        if (index > -1) {
          return this.jobs[index]['JobNo']
        } else {
          return null
        }
      } else {
        return null
      }
    },
    projectsObj () {
      let projectsObj = {}
      for (let project in this.projects) {
        projectsObj[this.projects[project].projectId] = this.projects[project]
      }
      return projectsObj
    },
    supplierSelectEngineers () {
      let arr = []
      this.engineers.forEach(engineer => {
        if (engineer.supplier === this.supplierSelect) {
          arr.push(engineer)
        }
      })
      return arr
    },
    assignToSupplierEngineers () {
      let arr = []
      this.engineers.forEach(engineer => {
        if (engineer.supplier === this.assignToSupplier) {
          arr.push(engineer)
        }
      })
      return arr
    },
    selectedSameProject () {
      let result = true
      if (this.selected.length === 0) {
        return true
      }
      let currentProject = this.selected[0]['Project']
      if (this.selected.length > 1) {
        for (let obj of this.selected) {
          if (currentProject !== obj.Project) {
            result = false
            break
          }
        }
      }
      if (result) {
        const index = this.projects.findIndex(project => {
          return project.projectId === currentProject
        })
        if (index > -1 && this.projects[index]['Supplier']) {
          this.assignToSupplier = this.projects[index]['Supplier']
        } else {
          this.assignToSupplier = null
        }
      }
      return result
    }
  },
  watch: {
    activeProject: function (val) {
      this.getJobs()
    },
    vehicleSelect: function (val) {
      if (val === null) {
        this.editedItem.Vehicle = null
        return
      }
      if (typeof val === 'string') {
        this.editedItem.vehReg = val
      } else {
        this.editedItem.vehReg = val.VehicleReg
      }
      const index = this.vehicles.findIndex(vehicle => {
        return vehicle.VehicleReg === this.editedItem.vehReg
      })
      if (index > -1) {
        this.editedItem.Vehicle = this.vehicles[index]['key']
      } else {
        this.editedItem.Vehicle = null
      }
      if (this.editedItem.templates.indexOf('IGVjrrgemWhH8zki8yBZ') > -1) {
        const vehicleObj = this.vehicles.find(vehicle => { return vehicle.key === this.editedItem.Vehicle })
        this.editedItem.extras['[Tacho Smart] VU Part Number'] = (vehicleObj && vehicleObj.VUPartNo ? vehicleObj.VUPartNo : '')
      }
    },
    selectTemplates: function (val) {
      this.editedItem.templates = val
      let vm = this
      let templateExtras = []
      let templateExtraKeys = []
      let keysToDelete = []

      const allTemplates = vm.templates
      const templates = vm.editedItem.templates
      if (templates) {
        templates.forEach(function (v) {
          // Stores the extras which match the currently selected templates in the data model. Can then be queried to make sure we only show the correct extras in the form etc.
          const arrayId = allTemplates.findIndex(function (obj) {
            return obj.key === v
          })
          if (allTemplates[arrayId]['extras'] !== undefined && allTemplates[arrayId]['extras'] !== null && allTemplates[arrayId]['extras'] !== '') {
            allTemplates[arrayId]['extras'].forEach(function (extra) {
              extra['key'] = allTemplates[arrayId]['key']
              templateExtras.push(extra)
              templateExtraKeys.push(extra.name)
            })
          }
        })
        for (let key in vm.editedItem.extras) {
          // Store names of extras which need to be deleted
          if (!templateExtraKeys.includes(key)) {
            keysToDelete.push(key)
          }
        }
        console.log(vm.editedItem)
        keysToDelete.forEach(function (keyName) {
          delete vm.editedItem.extras[keyName]
        })
        for (let key in templateExtraKeys) {
          // IF value of extras hasn't been set, set the value to the default found in db
          let obj = {}
          if (vm.editedItem.extras !== undefined) {
            if (!vm.editedItem.extras.hasOwnProperty(templateExtraKeys[key])) {
              var index = templateExtras.findIndex(obj => {
                return obj.name === templateExtraKeys[key]
              })
              if (index === -1) {
                obj[templateExtraKeys[key]] = ''
              } else {
                obj[templateExtraKeys[key]] = templateExtras[key]['default']
              }
              Object.assign(vm.editedItem.extras, obj)
            }
          } else {
            vm.editedItem.extras = {}
            obj[templateExtraKeys[key]] = ''
            Object.assign(vm.editedItem.extras, obj)
          }
          if (templates.indexOf('IGVjrrgemWhH8zki8yBZ') > -1) {
            const vehicleObj = this.vehicles.find(vehicle => { return vehicle.key === vm.editedItem.Vehicle })
            vm.editedItem.extras['[Tacho Smart] VU Part Number'] = (vehicleObj && vehicleObj.VUPartNo ? vehicleObj.VUPartNo : '')
          }
        }

        this.editedItem.templateExtras = templateExtraKeys
        this.templateExtras = templateExtras
        this.editedItem.extras = vm.editedItem.extras
      }
    },
    dialog (val) {
      if (!val) {
        this.close()
      }
    }
    // supplierSelect: function (val) {
    //   this.editedItem.Supplier = val
    //   this.getEngineers(val)
    // },
    // assignToSupplier: function (val) {
    //   this.getEngineers(val)
    // }
  },
  filters: {
    formatDate (val) {
      return val !== undefined && val !== null ? moment(val).format('DD/MM/YYYY') : null
    },
    arrayToString (val) {
      let str = ''
      if (val && typeof val === 'object') {
        val.forEach(arrayVal => {
          str += arrayVal + ', '
        })
        str = str.substr(0, str.length - 2)
      }
      return str
    },
    jobStatus (Status, Allocated) {
      if (Status === 3) {
        return 'Complete - NIBC Approved'
      } else if (Status === 2) {
        return 'Complete'
      } else if (Status === 1) {
        return 'Issue'
      } else {
        if (Allocated === '' || Allocated === null || Allocated === undefined) {
          return 'Not Started'
        } else {
          return 'Awaiting Install'
        }
      }
    }
  },
  methods: {
    saveEditedFinance () {
      this.savingEditedFinance = true
      for (let job in this.selectedJobs) {
        let thisJob = this.selectedJobs[job]
        let jobIndex = this.jobs.findIndex((jobToTest) => {
          return jobToTest.JobNo === thisJob.JobNo
        })
        let locationAddress = 'finance.' + thisJob.template
        fireStore.collection('Jobs').doc(this.jobs[jobIndex].id).update({[locationAddress]: { ...thisJob, ...this.editFinance }})
          .then(() => {
            this.jobs[jobIndex].finance[thisJob.template] = { ...thisJob, ...this.editFinance }
          })
          .catch(error => {
            console.log(error)
          })
      }
      this.selectedJobs = []
      this.$forceUpdate()
      this.savingEditedFinance = false
      this.editFinanceDialog = false
    },
    openEditFinanceDialog () {
      this.editFinance = {
        paymentMethods: this.selectedJobs[0].paymentMethods || null,
        contractTerm: this.selectedJobs[0].contractTerm || null,
        currency: this.selectedJobs[0].currency || null,
        upfrontPayment: this.selectedJobs[0].upfrontPayment || null,
        installationPayment: this.selectedJobs[0].installationPayment || null,
        rentalPayment: this.selectedJobs[0].rentalPayment || null,
        rentalFrequency: this.selectedJobs[0].rentalFrequency || null,
        lessor: this.selectedJobs[0].lessor || null,
        leaseFrequency: this.selectedJobs[0].leaseFrequency || null,
        leasePayment: this.selectedJobs[0].leasePayment || null,
        warranty: this.selectedJobs[0].warranty || null
      }
      this.editFinanceDialog = true
    },
    setProjectStates () {
      this.totalProjects = 0
      this.projectStates = [0, 0, 0, 0, 0]
      this.projects.forEach((data) => {
        if (data.Status === 'CTN Sheet Approved') {
          this.projectStates[1]++
        } else if (data.Status === 'In Progress') {
          this.projectStates[3]++
        } else if (data.Status === 'Complete') {
          this.projectStates[4]++
        } else if (data.Status === 'Cancelled') {
          this.projectStates[2]++
        } else {
          this.projectStates[0]++
        }
        this.totalProjects++
      })
    },
    getProjects () {
      this.projectTableLoading = true
      this.projects = []
      fireStore.collection('Projects')
      .get()
      .then(snap => {
        snap.forEach(doc => {
          let data = doc.data()
          data.id = doc.id
          this.projects.push(data)
        })
        this.setProjectStates()
        this.projectTableLoading = false
      })
    },
    getTemplates () {
      fireStore.collection('Templates').get()
      .then(snap => {
        snap.forEach(doc => {
          if (doc.id !== '' && doc.data().name !== 'Service Call' && doc.data().id !== 'preCheck' && doc.data().name !== 'Deinstall') {
            let obj = doc.data()
            obj.id = doc.id
            this.templates.push(obj)
          }
        })
      })
    },
    getJobs () {
      this.tableLoading = true
      this.jobs = []
      fireStore.collection('Jobs').where('Project', '==', this.activeProject)
      .get()
      .then(snap => {
        snap.forEach(doc => {
          let data = doc.data()
          data.id = doc.id
          this.jobs.push(data)
        })
        this.tableLoading = false
      })
    },
    getEngineers (supplier) {
      this.engineers = []
      fireStore.collection('Users').where('Role', 'in', ['Engineer', 'Supplier', 'Support and Engineer', 'Admin and Engineer'])
      .get()
      .then(snap => {
        snap.forEach(doc => {
          this.engineers.push({key: doc.data().UID, name: doc.data().Name, supplier: doc.data().Company})
        })
      })
    },
    getVehicles () {
      this.gettingVehicles = true
      this.vehicles = []
      fireStore.collection('Vehicles')
      .get()
      .then(snap => {
        snap.forEach(doc => {
          const data = doc.data()
          this.vehicles.push({key: doc.id, VehicleReg: data.VehicleReg ? data.VehicleReg : data.friendlyId, Customer: data.Customer, friendlyId: data.friendlyId})
        })
        this.gettingVehicles = false
      })
      .catch(() => {
        this.gettingVehicles = false
      })
    },
    closeProject () {
      this.projectDialog = false
      this.editedProject = this.defaultProject
    },
    editProject (item) {
      this.editedProjectIndex = this.projects.indexOf(item)
      this.editedProject = Object.assign({}, item)
      this.projectDialog = true
    },
    deleteProject (deleteJobs) {
      if (deleteJobs === true) {
        this.deletingProjectAll = true
      } else {
        this.deletingProjectOnly = true
      }
      const projectId = this.deleteProjectData.projectId
      const vm = this
      let index = this.projects.findIndex(function (obj) {
        return obj.id === vm.deleteProjectData.id
      })
      fireStore.collection('Projects').doc(vm.deleteProjectData.id)
      .delete()
      .then(() => {
        this.projects.splice(index, 1)
      })
      .catch(error => {
        console.log(error)
      })
      .then(() => {
        this.editedProject = this.defaultProject
        this.deleteProjectData = {}
        this.deleteProjectDialog = false
        this.projectDialog = false
        this.setProjectStates()
        this.deletingProjectOnly = false
      })
      .then(() => {
        if (deleteJobs === true) {
          var batch = fireStore.batch()
          this.jobs.forEach(job => {
            if (job.Project === projectId) {
              const batchJob = fireStore.collection('Jobs').doc(job.id)
              batch.delete(batchJob)
            }
          })
          batch.commit()
          .then(() => {
            this.deletingProjectAll = false
          })
        }
      })
    },
    deleteProjectModal (item) {
      this.deleteProjectData = item
      this.deleteProjectDialog = true
    },
    saveProject (closeDialog) {
      this.savingSaveProject = true
      let obj = this.editedProject
      const id = obj.id
      fireStore.collection('Projects').doc(id).update(obj)
      .then(() => {
        const index = this.projects.findIndex(project => {
          return project.id === obj.id
        })
        this.projects.splice(index, 1, obj)
        this.setProjectStates()
        this.savingSaveProject = false
        if (closeDialog === true) {
          this.projectDialog = false
        }
      })
      .catch(error => {
        console.log(error)
        this.saveProjectFailed = true
        this.savingSaveProject = false
      })
    },
    zeroFill (number, width) {
      width -= number.toString().length
      if (width > 0) {
        return new Array(width + (/\./.test(number) ? 2 : 1)).join('0') + number
      }
      return number
    },
    vehicleRegFromID (id) {
      const index = this.vehicles.findIndex(vehicle => {
        return vehicle.key === id
      })
      if (index > -1) {
        if (this.vehicles[index]['VehicleReg'] && this.vehicles[index]['VehicleReg'].length > 0) {
          return this.vehicles[index]['VehicleReg']
        } else {
          return this.vehicles[index]['friendlyId']
        }
      } else {
        return ''
      }
    },
    engineerNameFromID (id) {
      const index = this.engineers.findIndex(engineer => {
        return engineer.key === id
      })
      if (index > -1) {
        return this.engineers[index]['name']
      } else {
        return ''
      }
    },
    supplierNameFromID (id) {
      const index = this.suppliers.findIndex(supplier => {
        return supplier.key === id
      })
      return index > -1 ? this.suppliers[index].name : null
    },
    customerNameFromID (id) {
      const index = this.customerList.findIndex(customer => {
        return customer.key === id
      })
      return index > -1 ? this.customerList[index].name : null
    },
    templateNameFromId (id) {
      const index = this.templates.findIndex(template => {
        return template.id === id
      })
      if (index === -1) {
        return ''
      }
      return this.templates[index]['name']
    },
    expandedJobs (projectID) {
      let arr = []
      this.jobs.forEach(job => {
        if (job.Project === projectID) {
          arr.push(job)
        }
      })
      return arr
    },
    financeItemTotals (projectID) {
      let financeArr = this.financeItems
      let totals = {
        upfrontPaymentTotal: -1,
        installationPaymentTotal: -1,
        rentalPaymentTotal: -1,
        leasePaymentTotal: -1
      }
      financeArr.forEach(financeObj => {
        if (financeObj.paymentMethodsString.indexOf('Upfront Payment') > -1) {
          totals.upfrontPaymentTotal = parseInt(totals.upfrontPaymentTotal) + (financeObj.upfrontPayment ? parseInt(financeObj.upfrontPayment) : 0)
        }
        if (financeObj.paymentMethodsString.indexOf('Upfront Installation') > -1) {
          totals.installationPaymentTotal = parseInt(totals.installationPaymentTotal) + (financeObj.installationPayment ? parseInt(financeObj.installationPayment) : 0)
        }
        if (financeObj.paymentMethodsString.indexOf('Rental') > -1) {
          totals.rentalPaymentTotal = parseInt(totals.rentalPaymentTotal) + (financeObj.rentalPayment ? parseInt(financeObj.rentalPayment) : 0)
        }
        if (financeObj.paymentMethodsString.indexOf('Lease') > -1) {
          totals.leasePaymentTotal = parseInt(totals.leasePaymentTotal) + (financeObj.leasePayment ? parseInt(financeObj.leasePayment) : 0)
        }
      })
      return totals
    },
    exportFinance (projectID) {
      let financeArr = this.financeItems
      let financeTotals = this.financeItemTotals(projectID)
      let csv = ''
      this.financeHeaders.forEach(financeHeader => {
        csv += financeHeader.text + '\t'
      })
      csv += '\n'
      financeArr.forEach(financeObj => {
        csv += (financeObj.JobNo ? financeObj.JobNo : '') + '\t' + (financeObj.VehicleReg ? financeObj.VehicleReg : '') + '\t' + (financeObj.template ? this.templateNameFromId(financeObj.template) : '') + '\t' + (financeObj.paymentMethodsString ? financeObj.paymentMethodsString : '') + '\t' + (financeObj.contractTermText ? financeObj.contractTermText : '') + '\t' +
            (financeObj.currencyText ? financeObj.currencyText : '') + '\t' + (financeObj.upfrontPayment ? (financeObj.currencyText ? financeObj.currencyText : '') + financeObj.upfrontPayment : '') + '\t' + (financeObj.installationPayment ? (financeObj.currencyText ? financeObj.currencyText : '') + financeObj.installationPayment : '') + '\t' + (financeObj.rentalPayment ? financeObj.currencyText + financeObj.rentalPayment : '') + '\t' + (financeObj.rentalFrequencyText ? financeObj.rentalFrequencyText : '') + '\t' +
            (financeObj.lessorText ? financeObj.lessorText : '') + '\t' + (financeObj.leasePayment ? (financeObj.currencyText ? financeObj.currencyText : '') + financeObj.leasePayment : '') + '\t' + (financeObj.leaseFrequencyText ? financeObj.leaseFrequencyText : '') + '\t' + (financeObj.warrantyText ? financeObj.warrantyText : '') + '\n'
      })
      csv += '\t\t\t\t\t\t' + (financeTotals.upfrontPaymentTotal > -1 ? parseInt(financeTotals.upfrontPaymentTotal) + 1 : '') + '\t' + (financeTotals.installationPaymentTotal > -1 ? parseInt(financeTotals.installationPaymentTotal) + 1 : '') + '\t' + (financeTotals.rentalPaymentTotal > -1 ? parseInt(financeTotals.rentalPaymentTotal) + 1 : '') + '\t\t\t' + (financeTotals.leasePaymentTotal > -1 ? parseInt(financeTotals.leasePaymentTotal) + 1 : '')
      this.copyVarToClipboard(csv)
    },
    copyVarToClipboard (variable) {
      const el = document.createElement('textarea')
      el.value = variable
      el.setAttribute('readonly', '')
      el.style.position = 'absolute'
      el.style.left = '-9999px'
      document.body.appendChild(el)
      el.select()
      document.execCommand('copy')
      document.body.removeChild(el)
      this.copied = true
    }
  }
}
</script>


// WEBPACK FOOTER //
// Finance.vue?a4159818